import './index.scss';
import React from 'react';

import Multiple from './Multiple/Multiple';
import Single from './Single/Single';

class Select extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.isMultiple) {
      return <Multiple {...this.props} />;
    }

    return (
      <Single {...this.props} isManualExpensePrefilled={this.props.isManualExpensePrefilled} />
    );
  }
}

export default Select;
